module.exports = __webpack_public_path__ + "img/11(1).6f3a2d87.png";